import { gql } from "@apollo/client";

const PAIRING_RESULTS = gql`
  query pairingResults($id: Int!, $filter: ListPairingInput) {
    pairingResults(id: $id, filter: $filter)
  }
`;

export default PAIRING_RESULTS;
